// CONSTANTS
export const isInitialLoadReadyConstant = {
  SET_IS_INITIAL_LOAD_READY: 'SET_IS_INITIAL_LOAD_READY',
}

// ACTION TYPES
export type IsInitialLoadReadyActionTypes = {
  type: typeof isInitialLoadReadyConstant.SET_IS_INITIAL_LOAD_READY
  payload: boolean
}

// ACTION CALLS
export const IsInitialLoadReadyActions = {
  SET_IS_INITIAL_LOAD_READY: (payload: boolean): IsInitialLoadReadyActionTypes => ({
    type: Constants.SET_AB_TEST,
    payload,
  }),
}
